import type { CSSProperties, LinariaClassName } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo } from 'react';
import { format } from 'timeago.js';
import { timestampToDate } from '../../../../utilities/dates';
import "./NewModel.linaria.module.css!=!./NewModel?./NewModel.linaria.module.css?css=H4sIAAAAAAAAA22My2rDMBRE9/mKbAoNxMFSmzZVoL8iZFmvIF850pUfEfn3QIsDLl2emTlzENhxLTmxH+GSb4c1lktO6PRcyQCoAJlUgCqe75ufoV1pTyrCOwOVQ9WlP8ZX4gSn0Q2+tC71XsxMezUt9TBzEtI10KGMrkXLSF2/LKW58dm+141eU+lENA4qrzQy2j+/pFBq4sTBNQf4Tr2AIoMPkUXTvNLjcb8ltN5vKd0tBmlzPsVPfoI3Qpt/ot8XHQCrUTljkTXBt+f75gEbEpDFRgEAAA=="
const sixtyDaysMilliseconds = 5184000000;
const rootStyles = "atm_fc_1h6ojuz atm_h_1h6ojuz atm_9s_1txwivl atm_vy_1osqo2v atm_gz_yh40bf atm_caeex_1inquon atm_1duu8r7_8n312b";
interface NewModelBannerProps {
  timeClassName?: LinariaClassName;
  className?: LinariaClassName;
  timeStyle?: CSSProperties;
  style?: CSSProperties;
  compact?: boolean;
  creation: number;
}
const NewModelBanner = memo((props: NewModelBannerProps) => {
  const {
    timeClassName,
    timeStyle,
    className,
    creation,
    compact,
    style
  } = props;
  const creationMilliseconds = creation * 1000;
  const sixtyDaysAgo = Date.now() - sixtyDaysMilliseconds;
  const isOlderThanSixtyDays = creationMilliseconds < sixtyDaysAgo;
  return <div data-testid="Container__NewModelBanner" className={cx(rootStyles, className)} style={style}>
            Joined
            <span className={timeClassName} style={timeStyle}>
                {isOlderThanSixtyDays && (compact ? '' : ' a few') + ' months ago'}
                {!isOlderThanSixtyDays && format(timestampToDate(creationMilliseconds))}
            </span>
        </div>;
});
export default NewModelBanner;
export { NewModelBanner };